import CarrierLogo from "../CarrierLogo";

interface CarrierSummary {
  id: string;
  name: string;
  domain: string;
  hasImage: boolean;
}

const Carrier = ({ carrier }: { carrier: CarrierSummary }) => {
  return (
    <div className="flex flex-row gap-x-4">
      <CarrierLogo carrier={carrier} />
      <div className="flex flex-col">
        <div>{carrier.name}</div>
        <p className="text-gray-300">{carrier.domain}</p>
      </div>
    </div>
  );
};

export default Carrier;
